import React, { lazy, Suspense } from "react";
import "./App.css";
import "./styles/colors.css";
import "./styles/common-styles.css";
import "./styles/typography.css";
import Loader from "./components/Loader/Loader";

const PublicRoutes = lazy(() => import("./PublicRoutes"));

function App() {
  return (
    <div className="App">
      <Suspense fallback={<Loader />}>
        <PublicRoutes />
      </Suspense>
    </div>
  );
}

export default App;
